<template>
  <div>
    <div class="container mobile-logo">
      <div class="row">
        <div class="col-md-12">
          <img class="mb-4" src="../../assets/img/gofar-logo.png" alt="Logo" style="margin:15px;" />
        </div>
      </div>
    </div>
    <div class="container-fluid checkout-mobile" style="margin-bottom: 15px;">
      <div class="container">
        <div class="row checkout">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <table>
              <tbody>
                <tr>
                  <td class="cart-ico">
                    <svg width="20" height="19" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715c1.004 0 1.818-.813 1.818-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817zm9.18 0c1.004 0 1.817-.813 1.817-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817z"
                      ></path>
                    </svg>
                  </td>
                  <td v-on:click="toggleMobileSummaryVisibility">
                    <span v-if="!displaySummaryInMobileLayout"
                      >Show Order Summary
                      <svg width="11" height="6" xmlns="http://www.w3.org/2000/svg" class="dropdown-mobile" fill="#000">
                        <path
                          d="M.504 1.813l4.358 3.845.496.438.496-.438 4.642-4.096L9.504.438 4.862 4.534h.992L1.496.69.504 1.812z"
                        ></path>
                      </svg>
                    </span>
                    <span v-if="displaySummaryInMobileLayout">
                      Hide Order Summary
                      <svg width="11" height="7" xmlns="http://www.w3.org/2000/svg" class="dropdown-mobile" fill="#000">
                        <path
                          d="M6.138.876L5.642.438l-.496.438L.504 4.972l.992 1.124L6.138 2l-.496.436 3.862 3.408.992-1.122L6.138.876z"
                        ></path>
                      </svg>
                    </span>
                  </td>
                  <td class="price" v-if="this.products.length > 0">
                    {{ this.countrySetting.currencySymbol }}{{ this.subscription.grandTotal.toFixed(2) / 100 }}
                  </td>
                </tr>
              </tbody>
            </table>
            <transition name="fade">
              <div v-if="displaySummaryInMobileLayout">
                <CheckoutProducts
                  v-if="this.subscription.plan != null"
                  v-bind:plan="this.subscription.plan"
                  v-bind:products="this.products"
                  v-bind:currencySymbol="this.countrySetting.currencySymbol"
                ></CheckoutProducts>
                <CheckoutSummary
                  v-bind:subscription="this.subscription"
                  v-bind:products="this.products"
                  v-bind:shipment="this.shipment"
                  v-bind:currencySymbol="this.countrySetting.currencySymbol"
                ></CheckoutSummary>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row checkout">
        <div class="col-lg-1 col-md-1 d-none d-lg-block d-md-block">
          <div style="margin-top:60px;">
            <i class="bi bi-check-circle" style="font-size: 40px; color:#0093dc"></i>
          </div>
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <div class="row">
            <div class="col-md-3">
              <img
                stle="margin-left:-39px"
                class="mb-4 desktop-logo"
                src="../../assets/img/gofar-logo.png"
                alt="Logo"
                style="margin-top: 15px;"
              />
            </div>
          </div>
          <div class="row" style="margin-bottom: 20px;">
            <div class="row" style="margin-bottom: 25px;">
              <span><strong>Order#</strong> {{ orderId }}</span>
              <h6>Thank you for your order, {{ customer.firstName }}!</h6>
              <br />
              <br />
              <p>
                A confirmation email with the invoice has been sent to <strong>{{ customer.email }}</strong
                >. You will receive an email with your tracking code within 1 working day.
              </p>
            </div>
            <div class="row col-lg-12" style="margin-bottom: 10px;">
              <h6>Contact information</h6>
              <p><strong>Email:&nbsp;</strong>{{ customer.email }}</p>
            </div>
            <div class="row" style="margin-bottom: 15px;">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <h6>Shipping address</h6>
                <hr />
                <p style="line-height: 25px;">
                  <strong>{{ customer.firstName }} {{ customer.lastName }}<br /></strong>
                  <span v-if="customer.companyName">{{ customer.companyName }}<br /></span>
                  <span>{{ customer.address }}<br /></span>
                  <span v-if="customer.apartment">{{ customer.apartment }}<br /></span>
                  <span
                    >{{ customer.suburb || customer.city }} {{ customer.stateCode }} {{ customer.postalCode }}<br
                  /></span>
                  <span>{{ customer.country }}<br /></span>
                  <span>{{ customer.phone }}<br /></span>
                </p>
                <br />
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <h6>Billing address</h6>
                <hr />
                <p style="line-height: 25px;">
                  <strong>{{ customer.firstName }} {{ customer.lastName }}<br /></strong>
                  <span v-if="customer.companyName">{{ customer.companyName }}<br /></span>
                  <span>{{ customer.address }}<br /></span>
                  <span v-if="customer.apartment">{{ customer.apartment }}<br /></span>
                  <span
                    >{{ customer.suburb || customer.city }} {{ customer.stateCode }} {{ customer.postalCode }}<br
                  /></span>
                  <span>{{ customer.country }}<br /></span>
                  <span>{{ customer.phone }}<br /></span>
                </p>
              </div>
            </div>

            <div class="row">
              <span><strong>Shipping Method:</strong> {{ this.shipment.name }}</span>
            </div>
          </div>
          <div class="row">
            <p>
              If you have any questions about this order please contact
              <a href="mailto:support@gofar.co">support@gofar.co</a> for help.
            </p>
          </div>
          <div class="row">
            <p>
              <router-link
                :to="{
                  path: '/checkout',
                  query: {
                    products: this.selectedProductIds,
                    plan: this.selectedPlanId,
                    quantity: this.subscription.quantity,
                    coupon_code: this.coupon_code,
                    country_code: this.customer.country,
                    referral_code: this.referral ? `${this.referral.code}${this.referral.type}` : '',
                    referrer: this.referral ? this.referral.referrer : ''
                  }
                }"
                class="btn btn-process-order"
                style="font-size:14px;"
              >
                Place another order
              </router-link>
            </p>
          </div>
          <CheckoutFooter></CheckoutFooter>
        </div>
        <div class="col-lg-1 col-md-12 col-sm-12"></div>
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 checkout-right-panel">
          <CheckoutProducts
            v-if="this.subscription.plan != null"
            v-bind:plan="this.subscription.plan"
            v-bind:products="this.products"
            v-bind:currencySymbol="this.countrySetting.currencySymbol"
          ></CheckoutProducts>
          <CheckoutSummary
            v-bind:subscription="this.subscription"
            v-bind:products="this.products"
            v-bind:shipment="this.shipment"
            v-bind:currencySymbol="this.countrySetting.currencySymbol"
          ></CheckoutSummary>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckoutProducts from './components/CheckoutProducts.vue';
import CheckoutSummary from './components/CheckoutSummary.vue';
import CheckoutFooter from './components/CheckoutFooter.vue';
import * as helper from '../../helpers/helper';
import { SUPPORTED_CURRENCIES } from '../../helpers/constants';

export default {
  name: 'CheckoutFinish',
  components: { CheckoutSummary, CheckoutFooter, CheckoutProducts },
  data() {
    return {
      orderId: '',
      selectedProductIds: '',
      selectedPlanId: '',
      chargebee_subscription: null,
      subscription: null,
      shipment: null,
      customer: null,
      referral: null,
      coupon_code: '',
      countrySetting: null,
      displaySummaryInMobileLayout: false,
      hasTrackedPurchase: false
    };
  },
  created() {
    this.orderId = this.$route.query.order_id;
    this.subscription = JSON.parse(localStorage.getItem('subscription'));
    this.products = JSON.parse(localStorage.getItem('products'));
    this.customer = JSON.parse(localStorage.getItem('customer'));
    this.shipment = JSON.parse(localStorage.getItem('shipment'));
    this.referral = JSON.parse(localStorage.getItem('referral'));
    this.coupon_code = localStorage.getItem('coupon_code');
    this.chargebee_subscription = JSON.parse(localStorage.getItem('chargebee_subscription'));
    this.countrySetting = helper.getCountrySetting(this.customer.country);
    this.selectedProductIds = this.products.map((product) => {
      return SUPPORTED_CURRENCIES.some((currency_code)=> product.id.includes(currency_code)) ? product.id.slice(0, -4) : product.id
    }).join(',');
    console.log(this.selectedProductIds);
    this.selectedPlanId = SUPPORTED_CURRENCIES.some((currency_code)=> this.subscription.plan.id.includes(currency_code)) ? this.subscription.plan.id.slice(0, -4) : this.subscription.plan.id;
  },
  methods: {
    toggleMobileSummaryVisibility: function() {
      this.displaySummaryInMobileLayout = !this.displaySummaryInMobileLayout;
    },
    clearCheckoutData: function (){
      localStorage.removeItem('subscription');
      localStorage.removeItem('products');
      localStorage.removeItem('customer');
      localStorage.removeItem('shipment');
      localStorage.removeItem('referral');
      localStorage.removeItem('coupon_code');
      localStorage.removeItem('chargebee_subscription');
    },
    addProductsToDataLayer: function(subscriptionId) {
      if (this.hasTrackedPurchase) {
        console.log('Purchase already tracked. Skipping...');
        return;
      }

      if (!this.orderId || !this.subscription || !this.products) {
        console.log('Missing required data for GTM Tracking.');
        return;
      }

      if (!window.dataLayer) {
        console.warn('GTM dataLayer not ready, retrying...');
        setTimeout(() => this.addProductsToDataLayer(this.orderId), 300);
        return;
      }

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'purchase',
          pagePostType: 'page',
          pageCategory: ['chargebee-checkout-success-page'],
          ecommerce: {
            transaction_id: subscriptionId,
            affiliation: 'Chargebee checkout',
            value: this.subscription.grandTotal / 100,
            coupon: this.subscription.coupon,
            shipping: this.shipment.price / 100,
            currency: this.countrySetting.currencyCode,
            items: [
              ...this.products.map((product) => ({
                item_id: product.id,
                item_name: product.name,
                price: product.price / 100,
                quantity: product.quantity
              })),
              {
                item_id: this.subscription.plan.id,
                item_name: this.subscription.plan.name,
                price: this.subscription.plan.price / 100,
                quantity: this.subscription.quantity
              },
              {
                item_id: this.shipment.id,
                item_name: this.shipment.name,
                price: this.shipment.price / 100,
                quantity: 1 // Shipping quantity is always 1
              }
            ]
          }
        });
        this.hasTrackedPurchase = true;
      } catch (err) {
        console.error('Error tracking purchase event: ', err);
      }
    }
  },
  mounted() {
    // ensure DOM is ready and GTM has time to load
    this.$nextTick(()=> {
      setTimeout(()=> {
        this.addProductsToDataLayer(this.orderId);
      }, 150)
    })
  }
};
</script>
